import {
  observable,
  action
} from 'mobx'
import { store } from '../store.index';
export default class fwMobileTool {
  @observable toolMethodActive = '' // 设置当前选中的方法
  @observable showUseEncryption = false
  @observable hasInputOwnerPwd = false
  @observable protectSignNode = {}
  @observable commentStampNode = {}
  @observable permissionsInfo = {}
  @observable toolDisabled = false
  @observable pdfaEditable = true // pdfa文档是否可编辑
  @observable toolEditDisabled = false // 用于编辑状态的是否可用
  @observable closePopupViewFunc = null
  @observable toolMethodActiveFunction = null
  @observable handleActive = false
  @observable PencilPoint = false
  

  @action setToolDisabled(val) {
    this.toolDisabled = val
  }
  @action setPdfaEditable(val) {
    this.pdfaEditable = val
  }
  @action setToolEditDisabled(val) {
    this.toolEditDisabled = val
  }
  @action setClosePopupViewFunc(val) {
    this.closePopupViewFunc = val
  }
  @action setToolMethodActiveFunction(val) {
    this.toolMethodActiveFunction = val
  }
  
  @action setToolMethodActive(val) {
    if(!val) {
      this.defaultHandTool()
      if(this.toolMethodActiveFunction) {
        this.toolMethodActiveFunction(val)
      }
    } else {
      this.handleActive = false
      if(val === "stamp") {
        return
      }
      this.toolMethodActive = val
    }
  }
  @action setShowUseEncryption(val) {
    this.showUseEncryption = val
    if(this.closePopupViewFunc && val) {
      this.closePopupViewFunc()
    }
  }
  @action setHasInputOwnerPwd(val) {
    this.hasInputOwnerPwd = val
  }
  @action defaultHandTool = async () => {
    let compByName = await window.pdfui.getComponentByName("hand-tool")
    compByName.controller.handle()
    store.fwMobileToolStore.PencilPoint = ""
    this.handleActive = true
    this.toolMethodActiveFunction && this.toolMethodActiveFunction('')
  }
  
  @action closeUseEncryption = async () => {
    // 获取annot信息。清楚标记未加密的加密标记
    const currentPDFDoc = window.pdfui.pdfViewer.currentPDFDoc
    let allPage = currentPDFDoc.getPageCount()
    let pageIndex = 0
    let noteListArray = []
    while(allPage>0) {
      allPage--
      await store.fwMobileViewStore.loadAnnots(pageIndex).then(res => {
        noteListArray.push(res)
      })
      pageIndex++
    }
    noteListArray.map((items, page) => {
      items.map(item => {
        if(item.getType() === "redact") {
          window.pdfui.getPDFPageRender(page).then(pageRender => {
            return pageRender.getAnnotRenderSafely(item.id);
          }).then(annotRender => {
            annotRender.component.removeAnnot();
          });
        }
      })
    })
    // 切换手部操作，切换头部,取消选中加密状态
    this.setShowUseEncryption(false)
    this.setToolMethodActive('')
  }
  // 多页面加密
  @action pageEncryption(pages) {
    let pdfUi = window.pdfui
    if(pages.length == 0){
      return new Promise(resolve => {
        pdfUi.getPDFViewer().then(viewer => {
          pages = [viewer.getPDFDocRender().getCurrentPageIndex()];
          pdfUi.pdfViewer.currentPDFDoc.makeRedactByPages(pages).then(result => {
            this.memento(result);
            // this.useEncryption()
            resolve(result)
            // this.popop.hide();
          }).catch((err)=>{
            if(err.error===-6){
              pdfUi.alert("dialog.error.noRedactionLicense");
            }
          });
        });
      })
    }else{
      console.log(pages)  
      return new Promise(resolve => {
        pdfUi.pdfViewer.currentPDFDoc.makeRedactByPages(pages).then(result => {
          this.memento(result);
          // this.useEncryption()
          resolve(result)
          // this.popop.hide();
        }).catch((err)=>{
          if(err.error===-6){
            pdfUi.alert("dialog.error.noRedactionLicense");
          }
        });
      })
      
    }
  }
  @action memento(annots){
    let pdfUi = window.pdfui
    pdfUi.getPDFViewer().then(viewer => {
        let redacts=[];
        annots.map((annotArray)=>{
            let redact=annotArray[0];
            redacts.push(redact);
        });
        viewer.eventEmitter.emit("makeRedactByPagesSuccess",redacts);
    });
  }

  // 用于加密数据 prommiss参数
  // @observable permissionUtils =  window.UIExtension.PDFViewCtrl.shared;
  // 用于加密文档提交
  @action addPasswordSetSubmitCallback(userPassword, ownerPassword, permission, cipherType, isEncryptMetadata/*, valueChanged*/){
    this.setPasswordAndPermission(window.pdfui, {
      userPassword,
      ownerPassword,
      permission,
      cipherType,
      isEncryptMetadata,
    }).then(() => {
      window.sessionStorage.setItem("cachePageNewPassword", userPassword)
      window.sessionStorage.setItem('setPasswordAndPermission', true)
        // result ? this.popup.hide() : this.popup.showError();
    }).catch((e) => {
      console.log(e)
    });
  }
  @action setPasswordAndPermission = (pdfUI, data) => {
    if (!pdfUI || !data) return Promise.resolve(false);
    console.log()
    return pdfUI.pdfViewer.currentPDFDoc.setPasswordAndPermission(
        data.userPassword,
        data.ownerPassword,
        data.permission,
        data.cipherType,
        data.isEncryptMetadata,
    ).then((result) => {
      if (result) {
        pdfUI.alert({
            message: 'password-protect:warning.apply-to-document',
            level: 'warning',
            again: true,
        });
        pdfUI.eventEmitter.emit("security-type-changed");
        window.sessionStorage.setItem('setPasswordAndPermission', true)
        // setPwdPopupLatestUIData({...data, ...permissionUtils.convertPermissionToUIData(data.permission)});
        this.setHasInputOwnerPwd(true);
      }
      return result;
    });
  }
  // 加密信息2
  @action getPermissionsInfo() {
    const currentDoc = window.pdfui.pdfViewer.currentPDFDoc
    // TODO FOXIT 新版本修改: permissionUtils -> securityUtils
    // const { permissionUtils } = window.UIExtension.PDFViewCtrl.shared
    const { securityUtils } = window.UIExtension.PDFViewCtrl.shared

    return new Promise(() => {
      currentDoc.getStdCipherOptions().then((options) => {
        const uiData = Object.assign(
          securityUtils.getPermissionDefaultUIData(),
          options,
          securityUtils.convertPermissionToUIData(options.permission),
        );
        console.log(uiData)
        this.permissionsInfo = uiData
        if(uiData.change<3) {
          this.toolDisabled = true
          this.toolEditDisabled = true
        } else if (uiData.change === 3) {
          this.toolEditDisabled = true
          this.toolDisabled = false
        } else if (uiData.change === 0) {
          this.toolDisabled = true
          this.toolEditDisabled = true
        } else {
          this.toolDisabled = false
          this.toolEditDisabled = false
        }
      })
    })
  }
  // 获取文档的加密信息
  @action updataPassword(closeFunction) {
    const currentDoc = window.pdfui.pdfViewer.currentPDFDoc
    // TODO FOXIT 新版本修改: permissionUtils -> securityUtils
    // const { permissionUtils } = window.UIExtension.PDFViewCtrl.shared
    const { securityUtils } = window.UIExtension.PDFViewCtrl.shared
    console.log(securityUtils)
    return new Promise((resolve) => {
      currentDoc.getStdCipherOptions().then((options) => {
        const uiData = Object.assign(
          securityUtils.getPermissionDefaultUIData(),
          options,
          securityUtils.convertPermissionToUIData(options.permission),
        );
        if (currentDoc.hasOwnerPassword) {
          // 加密信息弹窗这个是我发起的
          this.requestOwnerPassword(window.pdfui, (ownerPassword) => {
              uiData.ownerPassword = ownerPassword;
              currentDoc.getUserPassword(ownerPassword).then((userPassword) => {
                  uiData.userPassword = userPassword;
                  resolve(uiData)
              });
          }, closeFunction);
        } else {
          currentDoc.getUserPassword('').then((userPassword) => {
              uiData.userPassword = userPassword;
              resolve(uiData)
          });
        }
      })
    })
  }
  @action requestOwnerPassword(pdfUI, callback, closeFunction) {
    if (!pdfUI) return;
    const currentDoc = pdfUI.pdfViewer.currentPDFDoc;
    const showPasswordPrompt = (error) => {
        return pdfUI.promptPassword(
            '',
            'password-protect:buttons.inputOwnerPassword',
            'password-protect:buttons.title',
            'body',
            error ? 'error' : undefined,
            error,
        );
    };
    const requestPassword = (password) => {
      if (!password) {
        closeFunction()
        return showPasswordPrompt('password-protect:error.admin-pwd-cannot-blank').then(requestPassword, () => {});
      }
      currentDoc.checkPassword(password).then((type) => {
          if (type === 3) {
            this.setHasInputOwnerPwd(true);
            this.setToolDisabled(false)
            this.setToolEditDisabled(false)
            callback && callback(password);
          } else {
            closeFunction()
            return showPasswordPrompt('password-protect:warning.incorrect-owner-pwd').then(requestPassword, () => {});
          }
      });
    };
    showPasswordPrompt().then(requestPassword, () => {
      closeFunction()
    });
  }

  // 搜索密文
  @action async loadSearches(word) {
    const currentPDFDoc = window.pdfui.pdfViewer.currentPDFDoc;
    const allPage = currentPDFDoc && currentPDFDoc.getPageCount()
    const docRender = await pdfui.pdfViewer.getPDFDocRender();
    const searchType = "redaction"
    const searchOption = {
      RangeOfWord: 900,
      autoSize: false,
      caseSensitive: false,
      highlight: false,
      includeAttachments: false,
      includeBookmarks: false,
      includeComments: false,
      isAlwaysShowMore: false,
      isIgnoreAsia: false,
      isIgnoreDiacritics: false,
      regExp: false,
      stemming: false,
      wholeWordsOnly: true,
    }
    let words = [word];

    if(words.some(w=>!w.length)){
        return Promise.resolve(false)
    }
    let remains = []
    for(let i = 0; i<allPage; i++) {
      remains.push(i)
    }

    // const remains = types.filter(type => !this.findResult[type]);
    let findResult = []
    if (remains.length != 0) {
      const doc = docRender.doc;
      const results = await doc.search(remains, words, searchOption, searchType == "redaction");
      for (let key in results) {
        findResult[key] = results[key];
      }
    }
    console.log(findResult)
    return Promise.resolve(findResult)
    // return types.reduce((ret, value) => {
    //   this.findResult[value].map((find, index) => {
    //     this.highlighter.highlight(find.pageIndex, find, index);
    //   });
    //   ret[value] = this.findResult[value];
    //   return ret;
    // }, {});
  }
  //跳转密文节点
  @action gotoResult(findResult){
    if(!findResult)return;

    const pdfUI = window.pdfui;
    //todo
    switch(findResult.type){
        case 'bookmark':
            pdfUI.getPDFViewer()
            .then(pdfViewer=>{
                const rootComponent = pdfViewer.viewerUI.rootComponent;
                rootComponent.getComponentByName('sidebar-bookmark').active();
                pdfui.getComponentByName('fv-bookmark-sidebar-panel')
                .then(bookmarkPanel=>bookmarkPanel.activeItem(findResult.id))
            })
            break;
        case 'annot':{
            const rect = findResult.rects[0];
            pdfUI.goToPage(findResult.pageIndex,rect.top,rect.left)
            .then(()=>pdfUI.getAnnotRender(findResult.pageIndex,findResult.id))
            .then(ar=>ar.active())
            // this.highlighter.select(-1,-1);
        }
            break;
        case 'pageText':
            const rect = findResult.rects[0];
            pdfUI.goToPage(findResult.pageIndex,rect.top,rect.left)
            .then(()=>
              this.goThisText(findResult)
              // this.selectCurrent(findResult)
            );
            break;
    }
  }
  // @action selectCurrent(result) {
  //   const highlighter = this.highlighter;
  //   if(result){
  //     highlighter.select(result.pageIndex, result.index);
  //     return;
  //   }
  //   const pageIndex = this.currentType;
  //   if (pageIndex != -1 && !highlighter.isPageHighlight(pageIndex)) {
  //     this.findResult[pageIndex].forEach((result, i) => {
  //       highlighter.highlight(pageIndex, result, i);
  //     });
  //   }
  //   highlighter.select(pageIndex, this.resultIndex);
  // }

  //跳转密文节点
  @action goThisText(data) {
    let pdfUi = window.pdfui;
    //跳转
    pdfUi.getPDFViewer().then(viewer => {
      let rects = data.rects;
      let top = rects[0].top,left=rects[0].left,right=rects[0].right,bottom=rects[0].bottom;
      rects.map((rect)=>{
          top=Math.max(rect.top,top);
          bottom=Math.min(rect.bottom,bottom);
          left=Math.min(rect.left,left);
          right=Math.max(rect.right,right);
      });
      let pageIndex = data.pageIndex;
      let scrollWrap = viewer.pdfViewerRender.scrollWrap;
      let viewTop = scrollWrap.getScrollTop(),
          viewBottom = viewTop+scrollWrap.getHeight(),
          viewLeft = scrollWrap.getScrollLeft(),
          viewRight = viewLeft+scrollWrap.getWidth();
      let pageRender = viewer.getPDFPageRender(pageIndex);
      let docRender = viewer.getPDFDocRender();
      let pagesRender = docRender.pagesRender;
      pagesRender.getPageScale(pageIndex,docRender.scale).then((scale)=>{
        pageRender.scale=scale;
        pageRender.getPDFPage().then((page)=>{
          let [pxLeft,pxTop]=page.getDevicePoint([left,top],pageRender.getScale(), pageRender.getRotation());
          const jumpAndSwitch = () => {
              viewer.getPDFDocRender().goToPage(pageIndex,{x:pxLeft,y:pxTop}).then(()=>{
                switchTo();
              })
          };
          // pageRender 的DOM节点可能不在DOM树上，所以不能直接用于判断坐标
          const ePageUI = pageRender.$ui.get(0);
          if(ePageUI.getClientRects().length === 0) {
              // 页面不可见
              jumpAndSwitch();
          } else {
              let offsetTop=pageRender.$ui[0].offsetTop+pxTop,
                  offsetLeft=pageRender.$ui[0].offsetLeft+pxLeft;
              if(offsetTop<viewTop||offsetTop>viewBottom||offsetLeft<viewLeft||offsetLeft>viewRight){
                jumpAndSwitch();
              }else {
                switchTo();
              }
          }
        })
      })
    });
    //切换高亮状态
    function switchTo() {
      pdfUi.getStateHandlerManager().then(stateHandlerManager => {
        const prevStateHandler=stateHandlerManager.getCurrentStates();
        stateHandlerManager.switchTo("checkTheSearch");
        pdfUi.getPDFViewer().then(viewer => {
            viewer.eventEmitter.emit("check-the-search", data, prevStateHandler);
        });
      });
    }
  }
  // 标记选中的 搜索出的节点
  @action async markRedaction(results){
    // const state = store.state;
    // const searchResult = state.searchResult;
    // const results = searchResult.checkedResults;

    console.log(results)

    if(!results.length)return;
    const docRender = await pdfui.pdfViewer.getPDFDocRender();
    const doc = docRender.doc;

    let start = 0;
    let count = -1;
    let wordList = []
    // wordList = searchOption.list
    // switch (state.searchMode) {
    //       case "profile":{
    //           const db = getRedactionProfileDb();
    //           const searchOption = await db.get(state.manageRedactionProfile.selectedProfile)
    //           wordList = searchOption.list
    //           break;
    //       }
    //   }
    return doc.redactSearch(results,start,count,wordList)
    .then(()=>{
      results.forEach(result=>{
        if(!result.isRedacted){
            // const isInCheckList = state.searchResult.checkedResults.some(i=>i.trackIndex===result.trackIndex && i.pageIndex===result.pageIndex);
            // if(isInCheckList){
            result.isRedacted = true;
            // }
        }
      });
      // window.pdfui.getPDFViewer().then(viewer => {
      //   let doc = viewer.getCurrentPDFDoc();
      //   doc.applyRedaction().catch(()=>{
      //     if(err.error===-6){
      //         pdfui.alert({ message: "dialog.error.noRedactionLicense", level: 'warning' });
      //     }else
      //       throw err;
      //   });
      //   doc.redacted = true;
      //   return Promise.resolve(true)
      // });
      
    })

  }
}
